module.exports = __webpack_public_path__ + "img/1-6.42751050.png";